import { SmartInput } from '@web/ui';

import type { TaskStatus } from '@/features/tasks/types';

type SelectTaskStatusValue = TaskStatus | 'all';

type SelectTaskStatusFieldProps = {
  value: SelectTaskStatusValue;
  onChange: (value: SelectTaskStatusValue) => void;
  name?: string;
  label?: string;
  error?: string;
  disabled?: boolean;
  size?: 'small' | 'medium';
  includeAllOption?: boolean;
  includeDraftOption?: boolean;
};

const TASK_STATUS_OPTIONS = [
  { value: 'backlog', label: 'Backlog' },
  { value: 'inprogress', label: 'In Progress' },
  { value: 'completed', label: 'Completed' },
  { value: 'archived', label: 'Archived' },
] as const;

export function SelectTaskStatusField({
  value,
  onChange,
  name = 'task-status',
  label,
  error,
  disabled = false,
  size = 'medium',
  includeAllOption = false,
  includeDraftOption = false,
}: SelectTaskStatusFieldProps) {
  const options = [
    ...(includeAllOption
      ? [{ value: 'all', label: 'All (not Archived)' as const }]
      : []),
    ...(includeDraftOption
      ? [{ value: 'draft', label: 'Draft' as const }]
      : []),
    ...TASK_STATUS_OPTIONS,
  ];

  return (
    <SmartInput
      type="select"
      name={name}
      label={label}
      size={size}
      value={value}
      options={options.map((option) => ({
        value: option.value,
        label: option.label,
      }))}
      error={error}
      readOnly={disabled}
      onChange={(nextValue) =>
        onChange(String(nextValue) as SelectTaskStatusValue)
      }
    />
  );
}

export type { SelectTaskStatusValue };
